module.exports = __webpack_public_path__ + "static/50ac1699-f3d2-47b6-878f-67a368a17c41-afc80fd38b63916e55b3434d6dc50aa8.woff";